import DraggableScrollDiv from "../../components/draggableScroll/DraggableScrollDiv";
import { useMedia, useMediaProduct } from "../../hooks";
import { useEffect, useImperativeHandle, useState } from "react";
import DragDropInput from "../../components/form/DragDropInput";

export default function ProductMobilePreview({ product, handleSubmitRef }) {
  const { media, createMediaProduct, deleteMediaProduct } = useMediaProduct(
    "webStore/",
    product?._id
  );
  const {
    media: img,
    createMediaProduct: createImg,
    deleteMediaProduct: deleteImg,
  } = useMediaProduct(`webStore/${product?._id}`, "");
  const [files, setFiles] = useState({});
  const [videoFile, setVideoFile] = useState({});
  const [imgFile, setImgFile] = useState({});

  useImperativeHandle(handleSubmitRef, () => ({
    submit() {
      handleSubmit();
    },
  }));

  function handleSubmit() {
    debugger;
    for (let key of Object.keys(media)) {
      if (key !== videoFile?.key) {
        // Delete
        deleteMediaProduct(product?._id, key);
      }
    }
    if (videoFile?.key) {
      if (media[videoFile?.key]) {
        deleteMediaProduct(product?._id, videoFile?.key);
      }
      // Post
      fileToDataURL(videoFile?.file, "Video");
    }
    for (let key of Object.keys(img)) {
      if (key !== imgFile?.key) {
        // Delete
        deleteImg("", key);
      }
    }
    if (imgFile?.key) {
      if (!img[imgFile?.key]) {
        // Post
        fileToDataURL(imgFile?.file, "Image");
      } else {
        // Put
        fileToDataURL(imgFile?.file, "Image", imgFile?.key);
      }
    }

    /*for (let [key, file] of Object.entries(files)) {
            if (!media[key]) {
                // Post
                fileToDataURL(file)
            } else{
                // Put
                fileToDataURL(file, key);
            }
        }*/
  }

  function changeCallback(newFile, name) {
    debugger;
    setVideoFile({ key: videoFile?.key ? videoFile.key : name, file: newFile });
  }

  function onDeleteCallback(name) {
    setVideoFile({});
  }

  function changeImgCallback(newFile, name) {
    setImgFile({ key: imgFile?.key ? imgFile.key : name, file: newFile });
  }

  function onDeleteImgCallback(name) {
    setImgFile({});
  }

  function fileToDataURL(file, type, filename = "") {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      createMediaProduct(
        product?._id,
        reader.result,
        filename,
        type === "Image",
        type
      );
    }; /*
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };*/
  }

  function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  useEffect(() => {
    //let newFiles = {...files};
    if (media) {
      let file;
      let fileKey;
      for (let [key, base64] of Object.entries(media)) {
        fileKey = key;
        file = dataURLtoFile("data:video/mp4;base64," + base64, "");
        //newFiles[key] = file;
      }
      //setFiles(newFiles);
      setVideoFile({ key: fileKey, file: file });
    }
  }, [media]);

  useEffect(() => {
    //let newFiles = {...files};
    if (img) {
      let file;
      let fileKey;
      for (let [key, base64] of Object.entries(img)) {
        fileKey = key;
        file = dataURLtoFile("data:image/png;base64," + base64, "");
        //newFiles[key] = file;
      }
      //setFiles(newFiles);
      setImgFile({ key: fileKey, file: file });
    }
  }, [img]);

  return (
    <div>
      <h1>{product?.name}</h1>

      <DraggableScrollDiv className={"mobile-preview m-t-20"} horizontal={true}>
        {img ? (
          <DragDropInput
            fileTypes={["JPG", "PNG"]}
            name={"file1"}
            style={{ width: "360px", height: "200px", marginTop: "10px" }}
            defaultValue={imgFile?.file}
            onChangeCallback={changeImgCallback}
            onDeleteCallback={onDeleteImgCallback}
          />
        ) : (
          <Loader />
        )}
        {media ? (
          <DragDropInput
            fileTypes={["MP4", "WEBM"]}
            name={"file0"}
            style={{ width: "360px", height: "200px", marginTop: "10px" }}
            defaultValue={videoFile?.file}
            onChangeCallback={changeCallback}
            onDeleteCallback={onDeleteCallback}
          />
        ) : (
          <Loader />
        )}
      </DraggableScrollDiv>
    </div>
  );
}

function Loader() {
  return (
    <div
      style={{
        width: "360px",
        height: "250px",
        border: "2px solid rgba(152, 166, 173, 0.5)",
        borderRadius: "5px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "grey",
      }}
      className={"status loading"}
    >
      <div className="icon loader-1 center">
        <span></span>
      </div>
    </div>
  );
}
